// extracted by mini-css-extract-plugin
module.exports = {"root":"EmptyCard_root__c1K6t","position":"EmptyCard_position__1hf6N","content":"EmptyCard_content__3LnEA"};